import { useState, type FormEvent } from 'react';
import styles from './HomeScreen.module.css';

interface Props {
  enrolling: boolean;
  onEnroll(code: string): void;
  onCancel(): void;
}

/** Aceita "ABCD-EFGH", "abcd efgh" etc.; mostra sempre como ABCD-EFGH. */
function normalizeCode(raw: string) {
  return raw.toUpperCase().replace(/[^0-9A-Z]/g, '').slice(0, 8);
}

function formatCode(code: string) {
  return code.length > 4 ? `${code.slice(0, 4)}-${code.slice(4)}` : code;
}

export function EnrollDeviceForm({ enrolling, onEnroll, onCancel }: Props) {
  const [input, setInput] = useState('');
  const code = normalizeCode(input);
  const ready = code.length === 8 && !enrolling;

  function submit(e: FormEvent) {
    e.preventDefault();
    if (ready) onEnroll(code);
  }

  return (
    <form className={styles.form} onSubmit={submit}>
      <p className={styles.enrollHint}>
        O proprietário gera o código em Empresa, na aba Dispositivos. Ele vale 15 minutos e só pode ser usado uma vez.
      </p>
      <input
        className={`${styles.input} ${styles.inputCompact}`}
        autoComplete="off"
        placeholder="ABCD-EFGH"
        aria-label="Código de vinculação"
        autoFocus
        value={formatCode(code)}
        onChange={(e) => setInput(e.target.value)}
      />
      <div className={styles.enrollActions}>
        <button type="button" className={styles.smallSecondary} onClick={onCancel} disabled={enrolling}>
          Cancelar
        </button>
        <button type="submit" className={styles.primary} disabled={!ready}>
          {enrolling ? 'Vinculando...' : 'Vincular'}
        </button>
      </div>
    </form>
  );
}
